import { alpha, createTheme } from '@mui/material/styles';

/** Blu brand (allineato a R-RAP2 / token UI Cantir) */
const CANTIR_BLUE = '#1B4FD8';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565C0',   // blue 800
      light: '#1E88E5',
      dark: '#0D47A1',
    },
    secondary: {
      main: '#FF6F00',   // amber 900 (cantiere)
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontSize: '18px', lineHeight: 1.3, fontWeight: 700 },
    h5: { fontSize: '18px', lineHeight: 1.3, fontWeight: 700 },
    h6: { fontSize: '18px', lineHeight: 1.3, fontWeight: 600 },
    subtitle1: { fontSize: '18px', lineHeight: 1.35, fontWeight: 600 },
    subtitle2: { fontSize: '16px', lineHeight: 1.4, fontWeight: 600 },
    body1: { fontSize: '16px', lineHeight: 1.5, fontWeight: 400 },
    body2: { fontSize: '16px', lineHeight: 1.5, fontWeight: 400 },
    button: { fontSize: '16px', lineHeight: 1.2, fontWeight: 600, textTransform: 'none' },
    caption: { fontSize: '14px', lineHeight: 1.4, fontWeight: 400 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
        maxWidth: false,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          paddingLeft: theme.spacing(1.5),
          paddingRight: theme.spacing(1.5),
          [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
          },
          [theme.breakpoints.up('md')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
        }),
        maxWidthXs: { maxWidth: 'none' },
        maxWidthSm: { maxWidth: 'none' },
        maxWidthMd: { maxWidth: 'none' },
        maxWidthLg: { maxWidth: 'none' },
        maxWidthXl: { maxWidth: 'none' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, fontSize: '16px' },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '16px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          lineHeight: 1.4,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          fontSize: '16px',
          lineHeight: 1.45,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: '14px',
          lineHeight: 1.3,
          fontWeight: 600,
        },
      },
    },
    /** Toggle, voci di lista, tab, ecc.: selected non più grigio, ma blu Cantir */
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            borderColor: alpha(CANTIR_BLUE, 0.5),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
    },
  },
});
